import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LegacyMemberService } from '../../../shared/service/legacy-member.service';

@Component({
    selector: 'odq-member-input',
    templateUrl: './member-input.component.html',
    styleUrls: ['./member-input.component.scss'],
    standalone: false
})
export class MemberInputComponent implements OnInit, OnDestroy {

  /**
   * ParentForm should have following fields :
   *   - permitNumber
   *   - firstName
   *   - lastName
   */
  @Input() parentForm: UntypedFormControl;
  @Input() previousPermitNumber?: string;
  @Input() hasChangeDate = false;
  @Input() readonly = false;
  @Input() findMemberWhenBlur = false;

  destroy$ = new Subject<void>();

  constructor(private legacyMemberService: LegacyMemberService) { }

  ngOnInit() {
    this.initMemberName();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // If Permit number is filled
  initMemberName() {
    const permitNumber = this.parentForm.get('permitNumber').value;

    if (permitNumber) {
      this.legacyMemberService.searchAllMembers(permitNumber)
        .pipe(takeUntil(this.destroy$))
        .subscribe(res => {
          if (res) {
            this.legacyMemberService.addMemberToCache(res);
            this.parentForm.patchValue({
              firstName: res.firstName,
              lastName: res.lastName,
            });
          }
        }, err => { /** important to keep this error handler to prevent a an error toast (silent error) */ });
    }
  }
  onBlur() {
    if (!this.findMemberWhenBlur) {
      return;
    }
    this.initMemberName();
  }

}
